import type { Client } from "../../_generated/client";

type RequestFunction<TQuery, TData> = (params: {
  client: Client | undefined;
  query: TQuery;
  signal: AbortSignal;
}) => Promise<{ data: TData; response: Response }>;

export default function cancelableRequest<TQuery, TData>(
  client: Client | undefined,
  requestFn: RequestFunction<TQuery, TData>,
  query: TQuery,
): {
  promise: Promise<{ data: TData; response: Response }>;
  abort: () => void;
} {
  const abortController = new AbortController();

  const promise = requestFn({
    client,
    query,
    signal: abortController.signal,
  });

  return {
    promise,
    abort: (): void => {
      abortController.abort();
    },
  };
}
